module.exports = __webpack_public_path__ + "img/3.60fbb5d7.png";